import React, {useState} from 'react';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ColleagueForSelector, UserRoles} from '../../../types/users';
import {assignTravelManager} from '../../../services/chats';
import {useTravelClaimQuery} from '../../../hooks/useTravelClaimQuery';
import {useUsersQuery} from "../../../hooks/useUsersQuery";
import {SelectDropdown} from "../../travelClaims/itemComponents/Inputs";
import {Modal as FlowbiteModal} from "flowbite-react";
import Close from "../../../assets/close.svg";
import {useAlert} from "../../../context/alert";

interface Props {
    claim_pk: string
    disabled?: boolean
}

export const AssignTravelManagerForm = ({claim_pk, disabled}: Props) => {
    const queryClient = useQueryClient();
    const {
        data: claim,
        isLoading: isLoadingClaim,
        isSuccess: isSuccessClaim
    } = useTravelClaimQuery((claim_pk || '').toString());

    const {setInfo} = useAlert();
    const {mutate: assign, isPending} = useMutation({
        mutationFn: assignTravelManager,
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: ['travelClaim', claim_pk.toString()],
            });
            setIsOpen(false);
            setInfo('Ответственный тревел-менеджер назначен');
        }
    });

    const submit = (userId: string | null) => {
        if (userId) {
            assign({
                claimPk: claim_pk,
                userId
            });
        }
    }

    const [user, setUser] = useState<ColleagueForSelector | null>(null);

    const handleUserChange = (user: ColleagueForSelector | null) => {
        setUser(user)
    }

    const [isOpen, setIsOpen] = useState<boolean>(false)
    const handleClose = () => {
        setIsOpen(false);
        setUser(null);
    }


    return (
        <>
            <FlowbiteModal
                show={isOpen}
                onClose={handleClose}
                size={'md'}
            >
                <div className="w-full flex p-6 relative bg-white rounded-lg">
                    {/*CONTAINER*/}
                    <div className="w-full inline-flex flex-col justify-between items-center">
                        {/*HEADER*/}
                        <div className="
                            w-full
                            mb-4
                            inline-flex
                            flex-row
                            justify-end
                            items-center
                            text-black text-2xl leading-[normal]
                            relative [font-family:'Acrom-Medium',Helvetica]
                            font-medium
                            tracking-[0]
                        ">
                            <div>
                                Назначить тревел-менеджера
                            </div>
                            {/*CLOSE BUTTON*/}
                            <button
                                onClick={handleClose}
                                className="
                                flex
                                justify-center
                                items-center
                                w-8 h-8
                                top-2.5
                                bg-[#f2f2f2] rounded-lg
                                overflow-hidden
                                "
                            >
                                <img src={Close} className=" w-6 h-6" alt="Manager ic close"/>
                            </button>
                        </div>
                        {/*BODY*/}
                        <div className="
                            w-full
                            min-h-32
                            inline-flex
                            flex-col
                            items-start
                            gap-4
                        ">
                            <SelectDropdown
                                filterParam={UserRoles.TRAVEL_MANAGER.toString() + ',' + UserRoles.TRAVEL_ADMIN.toString()}
                                fetchDataFunc={useUsersQuery}
                                onChange={handleUserChange}
                                selected={user}
                            />
                            <button
                                className={'p-3 rounded-lg w-full ' + (isPending ? 'bg-melon-light cursor-progress' : 'bg-melon-yellow')}
                                onClick={() => {
                                    submit(user?.pk || null);
                                }}
                            >
                                <div className='mx-auto'>
                                    Назначить
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </FlowbiteModal>
            <button
                className={'w-full my-0 px-1 py-3 rounded-lg ' + (disabled ? 'bg-gray-300 opacity-50 cursor-not-allowed' : 'bg-melon-yellow')}
                onClick={() => setIsOpen(true)}
                disabled={disabled}
            >
                <div className='my-auto text-[0.9em]'>
                    Назначить менеджера
                </div>
            </button>
        </>
    );
};
